import { ReactNode } from 'react';
import useInactivityTimer from 'Hooks/useInactivityTimer';
import { useLocation } from 'react-router-dom';
const inactivityTimeoutMinutes = Number(process.env.REACT_APP_INACTIVITY_TIMEOUT_MINUTES);

const InactivityProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const isBotPreviewChat = location.pathname.startsWith('/bot/preview/account/');
  useInactivityTimer(inactivityTimeoutMinutes, isBotPreviewChat);
  return <>{children}</>;
};

export default InactivityProvider;
